import { useState, useEffect } from 'react';
import { SegmentedControl, Snackbar, Cell } from '@telegram-apps/telegram-ui';
import VillasView from './components/VillasView';
import ArchiveView from './components/ArchiveView';
import { Villa } from './types';
import { fetchVillas, fetchArchived } from './api';
import './styles/App.css';

type Tab = 'villas' | 'archive';

const TABS = [
  { label: 'Виллы', value: 'villas' as const },
  { label: 'Архив', value: 'archive' as const },
];

function App() {
  const [currentTab, setCurrentTab] = useState<Tab>('villas');
  const [villas, setVillas] = useState<Villa[]>([]);
  const [archived, setArchived] = useState<Villa[]>([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState<string | null>(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const [villasData, archivedData] = await Promise.all([
        fetchVillas(),
        fetchArchived(),
      ]);
      setVillas(villasData.villas);
      setArchived(archivedData.villas);
    } catch (err) {
      console.error('Failed to load data:', err);
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (message: string) => {
    setSnackbar(message);
    setTimeout(() => setSnackbar(null), 3000);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleRefresh = () => {
    loadData();
    showSnackbar('Обновлено');
  };

  const handleTabChange = (value: string) => {
    if (value === 'villas' || value === 'archive') {
      setCurrentTab(value);
    }
  };

  return (
    <div className="app">
      {/* Header with Tab Control */}
      <div className="app__header">
        <SegmentedControl
          name="tabs"
          value={currentTab}
          options={TABS}
          onChange={handleTabChange}
        />
      </div>

      {/* Content */}
      {currentTab === 'villas' && (
        <VillasView
          villas={villas}
          loading={loading}
          onRefresh={handleRefresh}
          onChange={(updatedVilla) => {
            setVillas(prev => prev.map(v => v.id === updatedVilla.id ? updatedVilla : v));
          }}
          onMoveToArchive={(id) => {
            setVillas(prev => prev.filter(v => v.id !== id));
            loadData();
          }}
        />
      )}

      {currentTab === 'archive' && (
        <ArchiveView
          villas={archived}
          loading={loading}
          onRefresh={handleRefresh}
          onChange={(updatedVilla) => {
            setArchived(prev => prev.map(v => v.id === updatedVilla.id ? updatedVilla : v));
          }}
          onRestore={(id) => {
            setArchived(prev => prev.filter(v => v.id !== id));
            loadData();
          }}
        />
      )}

      {/* Snackbar */}
      <Snackbar
        onClose={() => setSnackbar(null)}
        open={snackbar !== null}
      >
        {snackbar}
      </Snackbar>
    </div>
  );
}

export default App;
